export default "__VITE_ASSET__9XttMOfa__"